<div class="row" *ngIf="isPrefence"><div class="col-md-12 mb-5" >
            
    <div class="alert alert-custom alert-light-danger fade show" role="alert" style="padding: 1rem 2rem;">
        <div class="alert-icon">
            <i class="flaticon-warning" style="
                    font-size: 1.3rem;
                "></i>
        </div>
        <div class="alert-text">Please update your tender preference setting for you to view and receive notification of
            tender based on your preferences.</div>
        <div >
            <!-- <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">
                    <i class="ki ki-close"></i>
                </span>
            </button> -->
         <a href="javascript: void(0);" class="btn btn-primary btn-sm mr-2" (click)="notification()">Update</a>
        </div>
    </div>
</div>
</div>